<div id="footer" class="col-lg-12 text-center">
  <p class="light">Privacy - Copyright © 2011-2019 Tutti i diritti riservati.</p>
</div>